<div *ngIf="buyers.length" (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table mat-table [dataSource]="buyers" class="sp-width__full">
    <ng-container matColumnDef="buyer_id">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'BUYERS.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <app-shared-id [content]="buyer.buyer_id" [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <span class="sp-color__primary sp-text__ellipsized"> {{ buyer.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <!--<ng-container matColumnDef="last_login">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.LAST_LOGIN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let buyer">
        <span
          *ngIf="buyer.last_login_at"
          class="sp-color__primary sp-text__ellipsized">
          {{ buyer.last_login_at | date : 'short' }}
        </span>
        <span *ngIf="!buyer.last_login_at"> - </span>
      </td>
    </ng-container>-->
    <ng-container matColumnDef="origin">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.ORIGIN_COLUMN_LABEL' | translate }}</span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <div class="sp-row__align">
          <mat-icon class="sp-color__accent sp-margin__right sp-icon__min-width"
            *ngIf="buyer?.origin == in_store_origin">
            storefront
          </mat-icon>
          <mat-icon class="sp-color__accent sp-margin__right sp-icon__min-width"
            *ngIf="buyer?.origin == website_origin">
            public
          </mat-icon>
          <mat-icon class="sp-color__accent sp-margin__right sp-icon__min-width"
            *ngIf="buyer?.origin == in_order_origin">
            receipt_long
          </mat-icon>
          <span class="sp-margin__quarter-left sp-text__ellipsized">
            {{ getOriginLabel(buyer?.origin) || '-' | translate }}
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.NAME_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <span *ngIf="buyer.firstname && buyer.lastname" class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ getFullName(buyer).length > 30 ? (getFullName(buyer) | slice : 0 : 30) + '...' : getFullName(buyer) }}
        </span>
        <span *ngIf="!buyer.firstname || !buyer.lastname"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.PHONE_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ buyer.phone.prefix }}
          {{ buyer.phone.value }}
        </span>
      </td>
    </ng-container>

    <!--<ng-container matColumnDef="email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let buyer">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ buyer.email }}
        </span>
      </td>
    </ng-container>-->

    <ng-container matColumnDef="current_login_attempts">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'BUYERS.LOGIN_ATTEMPTS_LABEL' | translate }}</span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <span class="sp-text__ellipsized">
          {{ buyer?.current_login_attempts || '0' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'BUYERS.STATUS_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <div class="sp-row__align">
          <app-shared-pill [content]="getOnboardingStatus(buyer)" [content_class]="'sp-color__primary'"
            [pill_class]="'sp-background__status-500'" [is_clear_enabled]="false"></app-shared-pill>

          <button (click)="onInfoClick(buyer); $event.stopPropagation()" mat-icon-button>
            <mat-icon color="accent"> info </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="is_confirmed">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'SELLERS.CONFIRMED_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <div class="sp-row__center">
          <mat-icon *ngIf="buyer.is_confirmed" color="accent">
            check_circle
          </mat-icon>

          <span *ngIf="!buyer.is_confirmed">-</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="on_boarding_steps">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'BUYERS.ONBOARDING_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <div class="sp-row__center">
          <mat-icon *ngIf="buyer.on_boarding_steps?.experian_verification_succeeded_at" color="accent">
            check_circle
          </mat-icon>

          <span *ngIf="!buyer.on_boarding_steps?.experian_verification_succeeded_at">-</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="lock">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <div class="sp-row__align">
          <mat-icon class="sp-color__accent sp-margin__right sp-icon__min-width material-symbols-outlined"
            *ngIf="buyer?.blocked_at || buyer?.blocked_by_admin">
            lock
          </mat-icon>
          <mat-icon class="sp-color__accent sp-margin__right sp-icon__min-width"
            *ngIf="!(buyer?.blocked_at || buyer?.blocked_by_admin)">
            lock_open
          </mat-icon>
          <span class="sp-margin__quarter-left sp-text__ellipsized"
            *ngIf="buyer?.blocked_at || buyer?.blocked_by_admin">
            {{ 'BUYERS.STATUS_BLOCKED' | translate }}
          </span>
          <span class="sp-margin__quarter-left sp-text__ellipsized"
            *ngIf="!(buyer?.blocked_at || buyer?.blocked_by_admin)">
            {{ 'BUYERS.STATUS_UNBLOCKED' | translate }}
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let buyer">
        <div class="sp-row__align">
          <button mat-icon-button class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>

          <button (click)="$event.stopPropagation()" mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left" [matTooltip]="'Menu' | translate"
            [mat-menu-trigger-for]="buyers_actions_menu">
            <mat-icon> more_horiz </mat-icon>
          </button>

          <mat-menu #buyers_actions_menu="matMenu">
            <button (click)="onChatClick(buyer); $event.stopPropagation()" class="sp-padding__vert" mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> chat </mat-icon>
              <span> {{ 'GENERAL.OPEN_CHAT_CTA' | translate }} </span>
            </button>

            <button (click)="onEditClick(buyer); $event.stopPropagation()" class="sp-padding__vert" mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> create </mat-icon>
              <span> {{ 'BUYERS.EDIT_CTA' | translate }} </span>
            </button>

            <button (click)="onRequestsClick(buyer); $event.stopPropagation()" class="sp-padding__vert" mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> list </mat-icon>
              <span> {{ 'GENERAL.SEE_REQUESTS_CTA' | translate }} </span>
            </button>

            <button (click)="onEditCreditCardClick(buyer); $event.stopPropagation()" class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> credit_card</mat-icon>
              <span> {{ 'BUYERS.EDIT_CREDIT_CARD_CTA' | translate }} </span>
            </button>

            <button (click)="onEditIbanClick(buyer); $event.stopPropagation()" class="sp-padding__vert" mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> account_balance </mat-icon>
              <span> {{ 'BUYERS.EDIT_IBAN_CTA' | translate }} </span>
            </button>

            <button (click)="onConfirmBuyerClick(buyer); $event.stopPropagation()"
              [disabled]="!(!buyer.is_confirmed || buyer.confirmed_by)" class="sp-padding__vert" mat-menu-item>
              <mat-icon *ngIf="!(buyer.is_confirmed && buyer.confirmed_by)"
                class="material-symbols-outlined sp-color__accent">
                check_circle_outline
              </mat-icon>
              <mat-icon *ngIf="buyer.is_confirmed && buyer.confirmed_by"
                class="material-symbols-outlined sp-color__accent">
                info
              </mat-icon>
              <span> {{ 'BUYERS.CONFIRM_USER_CTA' | translate }} </span>
            </button>

            <button (click)="onUnlockBuyerClick(buyer); $event.stopPropagation()" [disabled]="!buyer.blocked_at"
              class="sp-padding__vert" mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> lock_open </mat-icon>
              <span> {{ 'GENERAL.UNBLOCK_USER_CTA' | translate }} </span>
            </button>

            <button (click)="onToggleLockBuyer(buyer); $event.stopPropagation()" class="sp-padding__vert" mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"
                [ngClass]="buyer?.blocked_by_admin ? 'sp-color__primary' : 'sp-color__accent'">
                {{ buyer.blocked_by_admin ? 'lock' : 'lock_open' }}
              </mat-icon>
              <span> {{ 'BUYERS.TOGGLE_BLOCK_CTA' | translate }} </span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr mat-row class="sp-cursor__pointer" *matRowDef="let row; columns: displayed_columns"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>